import * as React from 'react';

import { BellIcon, MegaphoneIcon } from '@coursera/cds-icons';

import { CalendarListItem } from 'bundles/degree-home/components/v3-dpm/components/Calendar/CalendarListItem';
import { filterOptionValues } from 'bundles/degree-home/components/v3-dpm/components/Calendar/constants/constants';
import type { UseCalendarEvents_AcademicEventFragment as AcademicEvent } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCalendarEvents';

type Props = {
  academicEvent: AcademicEvent;
};

const AcademicEventItem: React.VFC<Props> = ({ academicEvent }) => {
  const eventName = academicEvent.eventTitle ?? '';
  const eventDescription = academicEvent.description ?? '';
  const isActionableEvent = !!academicEvent.actionLink;

  const itemIcon = isActionableEvent ? <MegaphoneIcon size="large" /> : <BellIcon size="large" />;

  return (
    <CalendarListItem
      itemIcon={itemIcon}
      itemTypeName={eventName}
      itemName=""
      // @ts-expect-error URL: string
      itemUrl={academicEvent.actionLink}
      subHeading={<span>{eventDescription}</span>}
      trackingName="degree_home_academic_event_link"
      courseId=""
      itemId={academicEvent.id}
      itemFilterType={filterOptionValues.Deadlines}
      hideColon
      openLinkInNewTab
      additionalTrackData={{ eventType: academicEvent.eventType }}
    />
  );
};

export default AcademicEventItem;
